// Cliente de dados do blog.
//
// Migrado do Supabase compartilhado para a API PHP hospedada no próprio site
// (/api), na conta Hostinger. Os nomes `supabase` e `blogDb` foram mantidos de
// propósito: as telas continuam iguais e a troca fica contida aqui.
//
// Para rollback, o git guarda a versão anterior deste arquivo.
import { bgApi } from '@/integrations/blog/api';

export const supabase = bgApi;
export const blogDb = bgApi;

// Cada site tem seu blog_id. Aqui ele é informativo: quem escopa de verdade é o
// servidor, pelo blog_id do api/config.php — que nunca vem do cliente.
export const BLOG_ID = '7af052a2-135a-4780-9fa2-04748fda8c4c';
